import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Briefcase, Code } from "lucide-react";

const RoleSelection = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleRoleSelect = async (role: "builder" | "sponsor") => {
    try {
      console.log('Selected role:', role);
      
      // Redirect to the appropriate onboarding page
      if (role === "builder") {
        navigate("/onboarding/builder");
      } else {
        navigate("/onboarding/sponsor");
      }
    } catch (error) {
      console.error('Error selecting role:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF94F] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-black mb-4 font-['OT_Bulb_Classic'] uppercase tracking-wide">Choose Your Role</h1>
          <p className="text-lg text-gray-800 font-['Public_Sans']">Select how you want to participate in Base Earn</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Builder Card */}
          <div 
            className="bg-white rounded-lg p-8 border-2 border-black shadow-[4px_4px_0px_black] hover:shadow-[6px_6px_0px_black] transition-all cursor-pointer"
            onClick={() => handleRoleSelect("builder")}
          >
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 bg-[#FAF94F] rounded-full flex items-center justify-center border-2 border-black">
                <Code className="w-8 h-8 text-black" />
              </div>
            </div>
            <h2 className="text-2xl font-bold text-center mb-4 font-['OT_Bulb_Classic'] uppercase">Join as Builder</h2>
            <p className="text-gray-800 text-center mb-6 font-['Public_Sans']">
              Create, contribute, and earn by building on Base. You'll need to provide:
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-center text-gray-800 font-['Public_Sans']">
                <span className="mr-2">•</span>
                Your name and contact info
              </li>
              <li className="flex items-center text-gray-800 font-['Public_Sans']">
                <span className="mr-2">•</span>
                Social media profiles
              </li>
              <li className="flex items-center text-gray-800 font-['Public_Sans']">
                <span className="mr-2">•</span>
                Skills and expertise
              </li>
              <li className="flex items-center text-gray-800 font-['Public_Sans']">
                <span className="mr-2">•</span>
                Profile picture
              </li>
            </ul>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleRoleSelect("builder");
              }}
              className="w-full bg-[#FAF94F] text-black hover:bg-[#f7e359] border-2 border-black shadow-[2px_2px_0px_black] py-6 text-lg font-['Public_Sans']"
            >
              Join as Builder
            </Button>
          </div>

          {/* Sponsor Card */}
          <div 
            className="bg-white rounded-lg p-8 border-2 border-black shadow-[4px_4px_0px_black] hover:shadow-[6px_6px_0px_black] transition-all cursor-pointer"
            onClick={() => handleRoleSelect("sponsor")}
          >
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 bg-[#FAF94F] rounded-full flex items-center justify-center border-2 border-black">
                <Briefcase className="w-8 h-8 text-black" />
              </div>
            </div>
            <h2 className="text-2xl font-bold text-center mb-4 font-['OT_Bulb_Classic'] uppercase">Join as Sponsor</h2>
            <p className="text-gray-800 text-center mb-6 font-['Public_Sans']">
              Post bounties and projects to find talented builders. You'll need to provide:
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-center text-gray-800 font-['Public_Sans']">
                <span className="mr-2">•</span>
                Company name and URL
              </li>
              <li className="flex items-center text-gray-800 font-['Public_Sans']">
                <span className="mr-2">•</span>
                Company social media
              </li>
              <li className="flex items-center text-gray-800 font-['Public_Sans']">
                <span className="mr-2">•</span>
                Company description
              </li>
              <li className="flex items-center text-gray-800 font-['Public_Sans']">
                <span className="mr-2">•</span>
                Company logo
              </li>
            </ul>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleRoleSelect("sponsor");
              }}
              className="w-full bg-[#FAF94F] text-black hover:bg-[#f7e359] border-2 border-black shadow-[2px_2px_0px_black] py-6 text-lg font-['Public_Sans']"
            >
              Join as Sponsor
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleSelection; 